import React, { PropsWithChildren } from "react";
import { classes } from "lib/actions/util";
import { useCurrentProject } from "lib/hooks/useProject";
import { useProjectFileUploadStarter } from "components/modules/Assets/lib/hooks/useProjectFileUploadStarter";
import UploadIcon from "components/icons/UploadIcons/upload.svg";

const FileDropzoneFullScreen = (
  props: PropsWithChildren<{
    className?: string;
    frostZoneClassName?: string;
  }>,
) => {
  const { startFiles } = useProjectFileUploadStarter();
  const { project, isProjectOpen } = useCurrentProject();
  const [isDroppingFile, setIsDroppingFile] = React.useState(false);

  let enterTarget = null;
  React.useEffect(() => {
    if (!isProjectOpen || !project?.canAddFiles) return;

    function onAddFiles(files: File[]) {
      startFiles(files);
    }
    const dragHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
      enterTarget = event.target;
      setIsDroppingFile(true);
    };

    const dragLeaveHandler = (event) => {
      if (enterTarget === event.target) {
        event.preventDefault();
        event.stopPropagation();
        setIsDroppingFile(false);
      }
    };

    const dropHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
      let files = [...event.dataTransfer.files];
      if (files && files.length > 0) {
        onAddFiles(files);
      }
      setIsDroppingFile(false);
    };

    document.addEventListener("dragenter", dragHandler);
    document.addEventListener("dragover", dragHandler);
    document.addEventListener("dragleave", dragLeaveHandler);
    document.addEventListener("drop", dropHandler);
    return () => {
      document.removeEventListener("dragenter", dragHandler);
      document.removeEventListener("dragover", dragHandler);
      document.removeEventListener("dragleave", dragLeaveHandler);
      document.removeEventListener("drop", dropHandler);
    };
  }, [isProjectOpen, project?.canAddFiles]);

  return (
    <div className={classes("relative", props.className)}>
      {props.children}
      {isDroppingFile && (
        <>
          <div
            className={classes(
              "absolute inset-0 z-50 bg-opacity-20 backdrop-blur-sm backdrop-filter",
              props.frostZoneClassName,
            )}
          >
            <div className="mx-auto mt-10 flex w-fit rounded-xl bg-white p-4 shadow">
              <UploadIcon className="mr-5 w-7 text-gray-500" />
              <span>
                Drop your files to upload them to the project{" "}
                <span className="font-semibold">{project?.name}</span>
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FileDropzoneFullScreen;
